import Vue from 'vue'

function setImgSrc (el, binding) {
  if (binding.oldValue === undefined || binding.value !== binding.oldValue) {
    const imageUrl = binding.value

    Vue.http.get(imageUrl, { responseType: 'arraybuffer' })
      .then(function (resp) {
        var mimeType = resp.headers.get('Content-Type').toLowerCase()
        var imgBase64 = Buffer.from(resp.body, 'binary').toString('base64')
        el.src = 'data:' + mimeType + ';base64,' + imgBase64
      })
      .catch(function (e) {
        el.src = imageUrl
      })
  }
}

const vueAuthImage = {}

vueAuthImage.install = function (Vue) {
  Vue.directive('auth-img', {
    bind: function (el, binding) {
      setImgSrc(el, binding)
    },
    componentUpdated: function (el, binding) {
      setImgSrc(el, binding)
    }
  })
}

export default vueAuthImage
